/**
 * An ordered list of supported roles. The order in which they are stored
 * dictates their hierachy.
 */
export const allowedRoles = ['INTERNALADMIN', 'ADMIN', 'EDITOR', 'OBSERVER', 'MACHINE'];
/**
 * A map of role to access level, represented as a graded scale where zero
 * assumes the highest level of access.
 */
export const allowedRolesIndex = Object.fromEntries(allowedRoles.map((role, i) => [role, i]));
/**
 * A map of role to accepted roles (used to quickly determine if a role can
 * operate on behalf of another role).
 */
export const allowedRolesMap = Object.fromEntries(allowedRoles.map((role, i) => [role, allowedRoles.slice(0, i + 1)]));
